export default __webpack_public_path__ + "402aac7fd0997339ca22784719367624.png";